import { Card, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { useSelector } from '../../../../redux/store';
import AwaitButton from '../../../../reusable-components/await-button/AwaitButton';
import { formCardStyle } from '../contractStyles';

ContractSaveCard.propTypes = {
    isEditable: PropTypes.bool
}
export default function ContractSaveCard({ isEditable = false }) {
    const { isLoading } = useSelector((state) => state.contracts || {});

    return (
        <Card sx={{ ...formCardStyle, px: 2 }}>
            <Grid container columnSpacing={2} rowSpacing={0}>
                <Grid item xs={6}>
                    <AwaitButton
                        variant="outlined"
                        size="small"
                        color="error"
                        type="submit"
                        disabled={true || !isEditable}
                        fullWidth
                    >
                        Delete Contract
                    </AwaitButton>
                </Grid>
                <Grid item xs={6}>
                    <AwaitButton
                        variant="contained"
                        size="small"
                        color="secondary"
                        type="submit"
                        disabled={isLoading || !isEditable}
                        fullWidth
                    >
                        Save Contract
                    </AwaitButton>
                </Grid>
            </Grid>
        </Card >
    );
}
